angular
    .module('app')
    .component('groupsList', {
        templateUrl: '/templates/pages/groups/groupsList/groupsList.html',
        controller: 'GroupsListController',
        controllerAs: 'vm',
    });